var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { key: "invite-team", staticClass: "t-onboard__body" }, [
    _c("div", { staticClass: "t-onboard__main" }, [
      _c("div", { staticClass: "t-onboard__content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "t-onboard__title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("onboard.register.invite_team.title")) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "t-onboard__description",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("onboard.register.invite_team.description", {
                domain: _vm.workspaceName,
              })
            ),
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "t-onboard__form" },
          [
            _c("div", { staticClass: "t-onboard__textarea t-mar--b-xs" }, [
              _c(
                "div",
                {
                  staticClass: "t-onboard__textarea-group",
                  class: { "t-onboard__textarea-error": _vm.invalidEmails },
                },
                [
                  !_vm.$isEmpty(_vm.emails)
                    ? _c(
                        "div",
                        { staticClass: "t-onboard__tags" },
                        _vm._l(_vm.emails, function (email, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "t-onboard__tag",
                              class: { "t-onboard__tag--error": email.error },
                            },
                            [
                              email.error
                                ? _c("i", {
                                    staticClass:
                                      "fas fa-exclamation-triangle fa-fw t-mar--r-mi",
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n                " +
                                  _vm._s(email.value) +
                                  "\n                "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "t-mar--l-mi t-dis--in-blk t-cursor--pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.remove(index)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fas fa-times fa-fw" })]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.emails.length < 5
                    ? _c("t-input", {
                        attrs: {
                          fluid: "",
                          placeholder: _vm.$t(
                            "onboard.register.invite_team.input.placeholder"
                          ),
                          type: "email",
                          variant: "text",
                        },
                        on: { keydown: _vm.keydown },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "t-button",
              {
                staticClass: "t-mar--t-sm",
                attrs: {
                  fluid: "",
                  variant: "primary",
                  size: "large",
                  loading: _vm.loader,
                },
                on: {
                  click: function ($event) {
                    return _vm.invite()
                  },
                },
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("onboard.register.invite_team.cta"))),
                ]),
                _vm._v(" "),
                _c("i", { staticClass: "fas fa-arrow-right fa-fw" }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "t-mar--t-md t-onboard__caption t-ta--right" },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("onboard.register.invite_team.skip"))),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.redirect()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("onboard.register.invite_team.later")) +
                        "\n          "
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "t-onboard__logo" }, [
      _c("img", {
        attrs: {
          src: require("@/lib/assets/images/Trainn-CB-logo.svg"),
          height: "36px",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }